const LandingHeadingText =({children, additionalclasses}) => {
    return (
        <p className={`text-[28px] lg:text-[40px] font-semibold text-grey-900 text-center ${additionalclasses}`}>
            {children}
        </p>
    );
}
export default LandingHeadingText;